import { render } from "./CommunicationReadySection.vue?vue&type=template&id=50328ca3&scoped=true"
import script from "./CommunicationReadySection.vue?vue&type=script&lang=js"
export * from "./CommunicationReadySection.vue?vue&type=script&lang=js"

import "./CommunicationReadySection.vue?vue&type=style&index=0&id=50328ca3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50328ca3"]])

export default __exports__